import { Dropdown } from "react-bootstrap";

const VehicleCategoriesTable = ({ categories, onEdit, onDelete, isDeleting }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Description</th>
            <th>No. of Seats</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category, index) => (
            <tr key={category._id || `${category.name}-${index}`}>
              <td>{index + 1}</td>
              <td>{category.name || "-"}</td>
              <td>{category.description || "-"}</td>
              <td>{category.noOfSeats ?? "-"}</td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle variant="link" className="p-0 text-decoration-none">
                    &#x2022;&#x2022;&#x2022;
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => onEdit(category._id)} disabled={!category._id}>
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => onDelete(category)}
                      className="text-danger"
                      disabled={!category._id || isDeleting}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VehicleCategoriesTable;
